module.exports = __webpack_public_path__ + "static/img/ios3.8b72ccf6.webp";